/** Fabric / canvas 2D composite operations useful as Photoshop-like blend modes. */
export const BLEND_MODES = [
  { id: 'source-over', label: 'Normal' },
  { id: 'multiply', label: 'Multiply' },
  { id: 'screen', label: 'Screen' },
  { id: 'overlay', label: 'Overlay' },
  { id: 'darken', label: 'Darken' },
  { id: 'lighten', label: 'Lighten' },
  { id: 'color-dodge', label: 'Color dodge' },
  { id: 'color-burn', label: 'Color burn' },
  { id: 'hard-light', label: 'Hard light' },
  { id: 'soft-light', label: 'Soft light' },
  { id: 'difference', label: 'Difference' },
  { id: 'exclusion', label: 'Exclusion' },
] as const;

export type BlendModeId = (typeof BLEND_MODES)[number]['id'];

export function normalizeBlendMode(value: unknown): BlendModeId {
  const id = typeof value === 'string' ? value : 'source-over';
  return BLEND_MODES.some((m) => m.id === id) ? (id as BlendModeId) : 'source-over';
}
